function timeConversion(timestamp) {
	// 创建一个新的Date对象，将时间戳作为参数传递
	var date = new Date(timestamp * 1000);
	// 获取年份、月份和日期
	var year = date.getFullYear();
	var month = ("0" + (date.getMonth() + 1)).slice(-2);
	var day = ("0" + date.getDate()).slice(-2);
	// 获取小时、分钟和秒
	var hours = ("0" + date.getHours()).slice(-2);
	var minutes = ("0" + date.getMinutes()).slice(-2);
	var seconds = ("0" + date.getSeconds()).slice(-2);
	// 格式化日期为字符串，例如：YYYY-MM-DD HH:MM:SS
	var formattedDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes;
	// var formattedDate = year + "-" + month + "-" + day ;

	return formattedDate;
}
export default timeConversion